import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  /**
   * Inset by the same 16px the toolbar below carries, so the first card's left edge and the last
   * card's right edge line up with the search field and the buttons rather than running to the
   * container's edges.
   */
  kpiRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: 16,
    padding: '0 16px',
    marginBottom: 16
  },
  kpiCard: {
    padding: '12px 16px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 4,
    backgroundColor: palette.common.white
  },
  kpiLabel: {
    color: palette.shades[700],
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    fontSize: 11,
    lineHeight: '16px',
    marginBottom: 4
  },
  /**
   * The line box is fixed rather than left to the glyph: an em dash and a digit have very different
   * natural heights, so without it the placeholder cards sit a few pixels off from the real one and
   * the row of four stops reading as a row.
   */
  kpiValue: {
    fontSize: 24,
    lineHeight: '30px',
    fontWeight: 600,
    color: palette.shades[900]
  },
  /** Reads as absent rather than as zero: a figure we cannot compute is not a figure of nought. */
  kpiValueUnavailable: {
    color: palette.shades[500]
  },
  kpiHint: {
    color: palette.shades[700],
    lineHeight: '18px',
    marginTop: 2
  },
  /**
   * Fixed rather than minimum width: on `minWidth` each select sized to its own label and the three
   * came out ragged, which is what stops the row reading as one control strip. The height is pinned
   * to the search field beside them for the same reason.
   */
  toolbarSelect: {
    width: 150,
    height: 40,
    backgroundColor: palette.common.white,
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      boxSizing: 'border-box',
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  /** The unset state is the label, so an untouched control reads as "everything", not as blank. */
  toolbarSelectPlaceholder: {
    color: palette.shades[800]
  },
  optionsPaper: {
    maxHeight: 320
  },
  optionLabel: {
    '& .MuiTypography-root': {
      fontSize: 14
    }
  }
});
export default useStyles;